export const camelToKebab = (key: string) =>
    key.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();

/** Builds { nameToSlug, slugToName } that are locale‑independent. */
export function buildSlugMaps<T extends Record<string, unknown>>(comps: T) {
    const nameToSlug: Record<keyof T, string> = {} as any;
    const slugToName: Record<string, keyof T> = {};

    (Object.keys(comps) as Array<keyof T>).forEach((name) => {
        const slug = camelToKebab(name as string);
        nameToSlug[name] = slug;
        slugToName[slug] = name;
    });

    return { nameToSlug, slugToName };
}
